<template>
  <div class="edit-obituary-comment__delete-content">
    <p v-text="texts.deleteComment.areYouSure" />

    <div class="edit-obituary-comment__button-group">
      <button
        class="btn danger"
        type="button"
        @click.prevent="deleteComment"
        v-text="texts.common.delete"
      />

      <button
        class="btn link"
        type="button"
        @click.prevent="toggleModal"
        v-text="texts.common.cancel"
      />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        texts: lavendlaObituary,
      };
    },

    methods: {
      deleteComment() {
        const data = {
          hash: this.hash,
          id: this.commentId,
        };
        this.$store
          .dispatch("comments/deleteObituaryComment", data)
          .then(() => this.toggleModal())
          .catch((error) => {
            if (error.serverMessage) {
              // biome-ignore lint/suspicious/noAlert: no in-page error UI exists for this form yet
              alert(error.serverMessage);
            } else {
              // biome-ignore lint/suspicious/noAlert: no in-page error UI exists for this form yet
              alert(this.texts.deleteComment.error);
            }
          });
      },
    },
    name: "DeleteCommentContent",

    props: {
      commentId: {
        required: true,
        type: String,
      },
      hash: {
        required: true,
        type: String,
      },
      toggleModal: {
        required: true,
        type: Function,
      },
    },
  };
</script>
